import React from 'react';
import { Envelope, MapPin, UserFocus } from '@phosphor-icons/react';
import { generateUniqueId } from './utils';

export const QUESTIONS = [
  {
    label: 'Department',
    type: 'Dropdown',
    showRequiredToggle: true,
    id: generateUniqueId(),
  },
  {
    label: 'CGPA',
    type: 'Short Text',
    id: generateUniqueId(),
  },
  {
    label: 'College Name',
    type: 'Short Text',
    id: generateUniqueId(),
  },
];

export const PRESET_QUESTIONS = [
  {
    label: 'Full Name',
    type: 'Short Text',
    id: 'full_name',
    isPreset: true,
    isRequired: true,
  },
  {
    label: 'Phone Number',
    type: 'Short Text',
    id: 'phone_number',
    isPreset: true,
    isRequired: true,
  },
];

export const QUESTIONS_TEMPLATE = [
  {
    label: 'Email',
    type: 'Email',
    leftIcon: <Envelope />,
  },
  {
    label: 'Blood Group',
    type: 'Dropdown',
    leftIcon: <UserFocus />,
  },
  {
    label: 'Gender',
    type: 'Dropdown',
    leftIcon: <UserFocus />,
  },
  {
    label: 'Country',
    type: 'Dropdown',
    leftIcon: <MapPin />,
  },
  {
    label: 'State',
    type: 'Dropdown',
    leftIcon: <MapPin />,
  },
  {
    label: 'City',
    type: 'Short Text',
    leftIcon: <MapPin />,
  },
  {
    label: 'Address',
    type: 'Short Text',
    leftIcon: <MapPin />,
  },
];
